import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";

export default function EuropassPdfIntroductionSection( { resumeData, translations } ) {
    const { introduction } = extractResumeDataDocumentSection( resumeData );
    const hasIntroduction = typeof introduction === 'string'
        ? introduction.trim() !== ''
        : Boolean( introduction );

    const styles = StyleSheet.create( {
        section: {
            flexDirection: 'row',
            marginBottom: 10,
            fontSize: 8,
            paddingHorizontal: 20,
            marginRight: 40
        },
        lineTitle: {
            height: 1,
            backgroundColor: "#979797",
            marginBottom: 5,
            marginTop: -5,
        },
    } );

    if ( !hasIntroduction ) {
        return null;
    }

    return (
        <View style={ styles.section }>
            <View style={ { marginTop: 10 } }>
                <View style={ { flexDirection: "row", marginBottom: 4 } }>
                    <Text style={ { fontSize: 11, marginRight: 3 } }>•</Text>
                    <Text style={ {
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        fontSize: 9,
                        marginTop: 2
                    } }>
                        { translations.pdf.introductionLabel }
                    </Text>
                </View>
                <View style={ [ styles.lineTitle, { marginTop: 1 } ] }/>
                <Text>{ introduction }</Text>
            </View>
        </View>
    );
}
